export enum EcheanceStatus {
  REFUSE = "Refusé",
  VALIDE_SNCF = "Validé SNCF",
  EN_ATTENTE_VALIDATION_CDS = "En attente de validation CDS",
  EN_ATTENTE_VALIDATION_SNCF = "En attente de validation SNCF",
  INFORMATION_MANQUANTE = "Information manquante",
  DEFAULT = "Défaut",
  VALIDE_AUTO = "Validé Auto"
}
